import {observer} from 'mobx-react-lite'
import React, {useEffect, useRef} from 'react'
import {Backend} from '@common/backend'
import {useForceUpdate, useGlobalKeyUp} from '@containers/hooks'
import {useFileViewerStore} from '../file-viewer-store'

export const VideoView = observer(() => {
  const [state] = useFileViewerStore()
  const ref = useRef<HTMLVideoElement>(null)

  const upd = useForceUpdate()
  useEffect(() => {
    upd()
  }, [state.currentFileIndex])

  useEffect(() => {
    ref.current?.load()
  }, [state.currentFile?.url])

  useGlobalKeyUp({
    anyKey: ({keyCode}) => {
      if (keyCode === 32 /* space */) {
        ref.current?.paused ? ref.current?.play() : ref.current?.pause()
      }
    }
  })

  return (
    <video
      controls
      className="flex h-full m-auto"
      ref={ref}
      autoPlay={state.autoplay}
    >
      <source src={Backend.toDataUrl(state.video.src)} />
    </video>
  )
})
